export const VALIDATION_RULES = {
  name: /^[a-zA-Z0-9\u00C0-\u017F\s',.\-&*]+$/,
  // Allow common special characters including + etc.
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: {
    minLength: 10,
    maxLength: 20,
  },
} as const;

export const ERROR_MESSAGES = {
  firstname: {
    required: 'Please enter the first name',
    invalid:
      "Please use only letters, numbers, spaces, and the following characters: , . - & * '",
  },
  lastname: {
    required: 'Please enter the last name',
    invalid:
      "Please use only letters, numbers, spaces, and the following characters: , . - & * '",
  },
  email: {
    required: 'Please enter the email address',
    invalid: 'Please enter a valid email address',
  },
  phone: {
    tooShort: 'Please enter a 10 digit phone number',
    tooLong: 'Phone number cannot be more than 20 digits',
  },
  userRole: {
    required: 'Please select a role',
  },
  serviceProvider: {
    servicesRequired: 'Please select services provided by service provider',
    companyNameRequired:
      'You must include a company name for a new service provider',
  },
} as const;
